let FujisanReader = {
  /**
   * fujisanReaderの起動URLを取得する
   */
  getReadingUrl: async function(url) {
    try {
      const response = await fetch('/wp-json/book/v2/read', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`${errorData.code}: ${errorData.message}`);
      }

      const redirectUrl = await response.text();
      return redirectUrl;
    } catch (error) {
      console.error('Error:', error.message);
      throw error;
    }
  },

  registEventHandler: function(selector, url) {
    $(selector).on("click", function(event) {
      event.preventDefault();

      FujisanReader.getReadingUrl(url)
        .then((redirectUrl) => {
          // リダイレクト処理を行う
          const url2 = JSON.parse(redirectUrl)['url'];
          if (!window.open(url2, "_blank")) {
            location.href = url2;
          }
        })
        .catch((error) => {
          // エラーハンドリング
          if (error.message.includes('unauthorized')) {
            // 再ログインを促すメッセージを表示するなど
          }
        });

    });
    console.debug("FujisanReader.registEventHandler()");
  }
}

export default FujisanReader;
